// Enhanced version with better configuration and responsive behavior

import { ReactElement, ReactNode, useEffect, useState, useCallback } from "react";
import useEmblaCarousel from "embla-carousel-react";
import './MobileSwiper.css';

interface MobileSwiperProps {
  children: ReactNode;
  className?: string;
}

export function MobileSwiper({ children, className = "" }: MobileSwiperProps) {
  // Enhanced configuration with better options
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: false, // Changed from true - better UX for tool selection
    align: 'start', // Align slides to start
    slidesToScroll: 1, // Scroll one item at a time
    containScroll: 'trimSnaps', // Better edge handling
    dragFree: true, // Allow free dragging for smoother feel
    skipSnaps: false, // Don't skip snaps
  });

  // Optional: Log when carousel is ready (for debugging)
  useEffect(() => {
    if (emblaApi) {
      // Carousel is ready
      console.log('Embla Carousel initialized');
    }
  }, [emblaApi]);

  return (
    <div className={`custom-swiper ${className}`} ref={emblaRef}>
      <div className="custom-swiper-track">
        {Array.isArray(children) ? (
          children.map((child, index) => (
            <div className="custom-swiper-slide" key={index}>
              {child}
            </div>
          ))
        ) : (
          <div className="custom-swiper-slide">{children}</div>
        )}
      </div>
    </div>
  );
}

// Swipeable section props interface
interface SwipeableSectionProps {
  title: string;
  children: ReactNode;
}

// Swipeable section component
function SwipeableSection({
  title,
  children,
}: SwipeableSectionProps): ReactElement {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    const checkMobile = (): void => {
      setIsMobile(window.innerWidth < 768); // Standard Bootstrap md breakpoint
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return (
    <div className="d-flex flex-column justify-content-center align-items-center mt-2">
      <div className="fs-4 mb-1 section-title">{title}</div>
      {isMobile ? (
        <MobileSwiper>{children}</MobileSwiper>
      ) : (
        <div className="d-flex flex-wrap justify-content-center gap-3 tool-name">
          {children}
        </div>
      )}
    </div>
  );
}

export default SwipeableSection;